import React from 'react';

function TField ({ isDisabled, ...props }) {
    return (
        <div className='px-[14px] w-[47.5%] p-2'>
            <div className="flex flex-row justify-between items-center py-[6px]">
                <label className='flex flex-col w-[calc(100%-440px)] justify-around font-"roboto" font-[400] text-[14px] leading-[15px] text-[#757575]'>{props.title}</label>
                <input
                    className='h-[38px] w-[440px] border-[1px] text-[#757575] border-[#E3E3E3] text-input w-3/5 bg-gray text-center outline-none'
                    id={`${props.id}.data`}
                    name={`${props.id}.data`}
                    type='text'
                    onChange={props.formikState.handleChange}
                    value={props.val.data}
                    disabled={isDisabled}
                />
            </div>
            <div className="flex flex-row justify-between items-center py-[6px]">
                <label className='flex flex-col w-[calc(100%-440px)] justify-around font-"roboto" font-[400] text-[14px] leading-[15px] text-[#757575]'>Start Time :</label>
                <input
                    className='h-[38px] w-[440px] border-[1px] text-[#757575] border-[#E3E3E3] text-input w-3/5 bg-gray text-center outline-none'
                    id={`${props.id}.stime`}
                    name={`${props.id}.stime`}
                    type='time'
                    onChange={props.formikState.handleChange}
                    value={props.val.stime}
                    disabled={isDisabled}
                />
            </div>
            <div className="flex flex-row justify-between items-center py-[6px]">
                <label className='flex flex-col w-[calc(100%-440px)] justify-around font-"roboto" font-[400] text-[14px] leading-[15px] text-[#757575]'>End Time :</label>
                <input
                    className='h-[38px] w-[440px] border-[1px] text-[#757575] border-[#E3E3E3] text-input w-3/5 bg-gray text-center outline-none'
                    id={`${props.id}.etime`}
                    name={`${props.id}.etime`}
                    type='time'
                    onChange={props.formikState.handleChange}
                    value={props.val.etime}
                    disabled={isDisabled}
                />
            </div>
            <div className="flex flex-row justify-between items-center py-[6px]">
                <label className='flex flex-col w-[calc(100%-440px)] justify-around font-"roboto" font-[400] text-[14px] leading-[15px] text-[#757575]'>Date :</label>
                <input
                    className='h-[38px] w-[440px] border-[1px] text-[#757575] border-[#E3E3E3] text-input w-3/5 bg-gray text-center outline-none'
                    id={`${props.id}.date`}
                    name={`${props.id}.date`}
                    type='date'
                    onChange={props.formikState.handleChange}
                    value={props.val.date}
                    disabled={isDisabled}
                />
            </div>
        </div>
    );
}

export default TField;
